// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3jVed","info":"UpdateTermsInfo_info__ALrWQ"};